(function () {
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var body = document.body;

  // Lampki
  var lights = document.getElementById("lights");
  if (lights && !lights.children.length) { for (var i = 0; i < 26; i++) lights.appendChild(document.createElement("span")); }

  // Odliczanie do Wigilii
  var dEl = document.getElementById("days");
  if (dEl) {
    var now = new Date();
    var target = new Date(now.getFullYear(), 11, 24);
    if (now > target) target = new Date(now.getFullYear() + 1, 11, 24);
    var d = Math.ceil((target - now) / 86400000);
    dEl.textContent = d;
    var wEl = document.getElementById("daysWord");
    if (wEl) wEl.textContent = d === 1 ? "dzień do Wigilii" : "dni do Wigilii";
  }

  // Wejście sekcji
  var items = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove("pre"); io.unobserve(en.target); } });
    }, { threshold: 0.08 });
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add("pre"); io.observe(el); }
    });
  }

  // Strona produktu: zdjęcia, wersje, ilość
  var pf = document.querySelector("[data-product-form]");
  if (pf) {
    var main = document.querySelector("[data-main-img]");
    document.querySelectorAll("[data-thumb]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (main) { main.src = b.getAttribute("data-src"); }
        document.querySelectorAll("[data-thumb]").forEach(function (x) { x.setAttribute("aria-current", "false"); });
        b.setAttribute("aria-current", "true");
      });
    });
    var sel = pf.querySelector("[data-variant-select]");
    var priceEl = document.querySelector("[data-price]");
    var buyBtns = pf.querySelectorAll("[data-buy]");
    function applyVariant() {
      if (!sel) return;
      var o = sel.options[sel.selectedIndex];
      if (priceEl) {
        var p = o.getAttribute("data-price"), c = o.getAttribute("data-compare"), pc = o.getAttribute("data-percent");
        priceEl.innerHTML = p + (c ? ' <s>' + c + '</s> <span class="sale">−' + pc + '%</span>' : '');
      }
      var img = o.getAttribute("data-image");
      if (img && main) main.src = img;
      var avail = o.getAttribute("data-available") === "true";
      buyBtns.forEach(function (b) { b.disabled = !avail; });
      var add = pf.querySelector("[data-add]");
      if (add) add.textContent = avail ? "Dodaj do koszyka" : "Wyprzedane";
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set("variant", o.value); history.replaceState({}, "", u);
      }
    }
    if (sel) { sel.addEventListener("change", applyVariant); }
    var q = pf.querySelector("[data-qty]");
    pf.querySelectorAll("[data-qty-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = parseInt(q.value, 10) || 1; v += parseInt(b.getAttribute("data-qty-step"), 10);
        q.value = Math.max(1, Math.min(99, v));
      });
    });
  }

  // Koszyk: zmiana ilości
  document.querySelectorAll("[data-cart-step]").forEach(function (b) {
    b.addEventListener("click", function () {
      var inp = b.parentNode.querySelector("input"); var v = parseInt(inp.value, 10) || 0;
      v += parseInt(b.getAttribute("data-cart-step"), 10); inp.value = Math.max(0, Math.min(99, v));
      var f = document.getElementById("cart-form"); if (f) { var u = document.createElement("input"); u.type = "hidden"; u.name = "update"; u.value = "1"; f.appendChild(u); f.submit(); }
    });
  });

  // Śnieg
  var cv = document.getElementById("snow");
  if (!cv || !cv.getContext || body.getAttribute("data-snow") === "false") { if (cv) cv.hidden = true; return; }
  var ctx = cv.getContext("2d");
  var w = 0, h = 0, flakes = [];
  function size() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = window.innerWidth; h = window.innerHeight;
    cv.width = w * dpr; cv.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function make() { return { x: Math.random() * w, y: Math.random() * h, r: .8 + Math.random() * 2, v: .3 + Math.random() * .7, s: Math.random() * 6.28 }; }
  size();
  var count = w < 600 ? 40 : 90;
  for (var k = 0; k < count; k++) flakes.push(make());
  window.addEventListener("resize", size);
  var running = true;
  document.addEventListener("visibilitychange", function () { running = !document.hidden; if (running) loop(); });
  function loop() {
    if (!running) return;
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = "#f7eedd";
    for (var j = 0; j < flakes.length; j++) {
      var f = flakes[j];
      f.y += f.v; f.s += .012; f.x += Math.sin(f.s) * .35;
      if (f.y > h + 4) { f.y = -4; f.x = Math.random() * w; }
      ctx.globalAlpha = Math.min(.85, f.r / 2.4);
      ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.2832); ctx.fill();
    }
    requestAnimationFrame(loop);
  }
  loop();
})();
